module.exports = __webpack_public_path__ + "static/media/play.3137575b.svg";